import PageContainer from '@/components/ui/containers/PageContainer'
import { StatsContainer } from './container/StatsContainer'
import { MonthlyReportTab } from '@/pages/admin/statistics/ui/monthly-report/MonthlyReportTab'
import { Tabs, Tab, Box } from '@mui/material'
import { useState } from 'react'
import { t } from '@lingui/macro'

export function StatisticsPage() {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <PageContainer>
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
        >
          <Tab label={t`Overview`} />
          <Tab label={t`Monthly Report`} />
        </Tabs>

        <div role="tabpanel" hidden={activeTab !== 0}>
          {activeTab === 0 && <StatsContainer />}
        </div>

        <div role="tabpanel" hidden={activeTab !== 1}>
          {activeTab === 1 && (
            <Box sx={{ py: 3 }}>
              <MonthlyReportTab establishmentId="all" isSuperAdmin={true} />
            </Box>
          )}
        </div>
      </Box>
    </PageContainer>
  )
}

export default StatisticsPage
